// English comments only

const DEVICE_ID_COOKIE = "deviceId";
const DEVICE_ID_MAX_AGE_SEC = 10 * 365 * 24 * 60 * 60;
const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function isValidDeviceId(value) {
  return typeof value === "string" && UUID_V4_REGEX.test(value.trim());
}

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function getDeviceIdCookieDomain() {
  if (typeof window === "undefined") return null;

  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return null;
  if (host === "pallas-invictus.com" || host.endsWith(".pallas-invictus.com")) {
    return ".pallas-invictus.com";
  }

  return null;
}

function writeDeviceIdCookie(deviceId) {
  const parts = [
    `${DEVICE_ID_COOKIE}=${encodeURIComponent(deviceId)}`,
    "path=/",
    `max-age=${DEVICE_ID_MAX_AGE_SEC}`,
    "SameSite=Strict",
  ];

  const domain = getDeviceIdCookieDomain();
  if (domain) parts.push(`domain=${domain}`);
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    parts.push("Secure");
  }

  document.cookie = parts.join("; ");
}

function generateDeviceId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const rand = Math.floor(Math.random() * 16);
    const value = char === "x" ? rand : (rand & 0x3) | 0x8;
    return value.toString(16);
  });
}

/**
 * Returns a stable device id for this browser, shared across dev/prod subdomains.
 */
export function ensureDeviceId() {
  const existing = readCookie(DEVICE_ID_COOKIE);
  if (isValidDeviceId(existing)) {
    return existing.trim();
  }

  const deviceId = generateDeviceId();
  writeDeviceIdCookie(deviceId);
  return deviceId;
}

export function getDeviceId() {
  const existing = readCookie(DEVICE_ID_COOKIE);
  return isValidDeviceId(existing) ? existing.trim() : null;
}
